import {
  baseVendorApiSettingsDefaults,
  defaultHttpAgentSettings,
  defaultPaginationSettings,
  defaultRateLimitationSettings,
  defaultSessionSettings,
  defaultVendorApiHttpAdvancedSettings,
} from './base';
import type { RuckusVszApiSettingsDefaults } from './types';

export const ruckusVszDefaults: RuckusVszApiSettingsDefaults = {
  ...baseVendorApiSettingsDefaults,
  ...defaultHttpAgentSettings,
  ...defaultPaginationSettings,
  ...defaultRateLimitationSettings,
  ...defaultSessionSettings,
  ...defaultVendorApiHttpAdvancedSettings,
  maxConcurrentRequests: 10,
  defaultSessionTimeoutSec: 0,
};
